import { useEffect, useRef } from "react";

const dirtySources = new Set<symbol>();

export const hasUnsavedReleaseChanges = (): boolean => dirtySources.size > 0;

export const useReleaseDirtyState = (dirty: boolean): void => {
  const source = useRef<symbol>(undefined);
  if (source.current === undefined) source.current = Symbol("release-dirty-source");

  useEffect(() => {
    const token = source.current;
    if (token === undefined) return;
    if (dirty) dirtySources.add(token);
    else dirtySources.delete(token);

    return () => {
      dirtySources.delete(token);
    };
  }, [dirty]);
};
